var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    {
      staticClass: "IkFormNumber",
      attrs: { label: _vm.name, required: _vm.getRequire },
    },
    [
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: {
            disabled:
              _vm.tips === "" || _vm.tips === null || _vm.tips === undefined,
            effect: "dark",
            content: _vm.tips,
            placement: "top",
          },
        },
        [
          _c("el-input-number", {
            attrs: {
              type: "text",
              size: "mini",
              disabled: _vm.disabled,
              precision: _vm.precision,
              min: _vm.min,
              max: _vm.max,
              step: _vm.step,
            },
            on: { input: _vm.input },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          }),
        ],
        1
      ),
      _vm.errorSign
        ? _c(
            "el-tooltip",
            {
              staticClass: "right",
              attrs: { effect: "dark", content: _vm.message, placement: "top" },
            },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }